import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../../contexts/AuthContext";

const CreateChallengeForm = ({ stageId, stageName, onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    name: "",
    duration: 60,
    start_at: "",
    end_at: "",
    status: "in_progress",
    order: 1,
    tournament_stage_id: stageId,
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { apiBaseUrl } = useAuth();

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      setMessage("نام چلنج الزامی است");
      return false;
    }
    if (!formData.start_at) {
      setMessage("تاریخ شروع الزامی است");
      return false;
    }
    if (!formData.end_at) {
      setMessage("تاریخ پایان الزامی است");
      return false;
    }
    if (formData.duration <= 0) {
      setMessage("مدت زمان باید بیشتر از صفر باشد");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    setMessage("");

    try {
      const payload = {
        name: formData.name.trim(),
        duration: Number(formData.duration),
        start_at: formData.start_at,
        end_at: formData.end_at,
        status: formData.status,
        order: Number(formData.order),
        tournament_stage_id: Number(stageId),
      };

      const response = await axios.post(
        `${apiBaseUrl}/api/tournament/admin`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      setMessage("چلنج با موفقیت ایجاد شد");

      setTimeout(() => {
        onSuccess();
      }, 1000);
    } catch (error) {
      console.error("Error:", error);
      setMessage(error.response?.data?.message || "خطا در ایجاد چلنج");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-800 border border-gray-600 rounded-lg p-6">
      <div className="mb-4">
        <h4 className="text-white font-medium text-lg">
          ایجاد چلنج جدید برای استیج: {stageName}
        </h4>
        <p className="text-gray-400 text-sm mt-1">Stage ID: {stageId}</p>
      </div>

      {message && (
        <div
          className={`p-4 rounded-lg text-center mb-4 ${
            message.includes("موفقیت")
              ? "bg-green-900 border border-green-600 text-green-400"
              : "bg-red-900 border border-red-600 text-red-400"
          }`}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* نام چلنج */}
          <div>
            <label className="block text-white font-medium mb-2">
              نام چلنج: <span className="text-red-400">*</span>
            </label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => handleChange("name", e.target.value)}
              placeholder="مثال: Speed Run Challenge"
              className="w-full p-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:border-green-500 focus:outline-none"
            />
          </div>

          {/* مدت زمان */}
          <div>
            <label className="block text-white font-medium mb-2">
              مدت (روز): <span className="text-red-400">*</span>
            </label>
            <input
              type="number"
              value={formData.duration}
              onChange={(e) => handleChange("duration", e.target.value)}
              min="1"
              className="w-full p-3 bg-gray-900 border border-gray-600 rounded-lg text-white focus:border-green-500 focus:outline-none"
            />
          </div>

          {/* تاریخ شروع */}
          <div>
            <label className="block text-white font-medium mb-2">
              تاریخ شروع: <span className="text-red-400">*</span>
            </label>
            <input
              type="datetime-local"
              value={formData.start_at}
              onChange={(e) => handleChange("start_at", e.target.value)}
              className="w-full p-3 bg-gray-900 border border-gray-600 rounded-lg text-white focus:border-green-500 focus:outline-none"
            />
          </div>

          {/* تاریخ پایان */}
          <div>
            <label className="block text-white font-medium mb-2">
              تاریخ پایان: <span className="text-red-400">*</span>
            </label>
            <input
              type="datetime-local"
              value={formData.end_at}
              onChange={(e) => handleChange("end_at", e.target.value)}
              className="w-full p-3 bg-gray-900 border border-gray-600 rounded-lg text-white focus:border-green-500 focus:outline-none"
            />
          </div>

          {/* وضعیت */}
          <div>
            <label className="block text-white font-medium mb-2">وضعیت:</label>
            <select
              value={formData.status}
              onChange={(e) => handleChange("status", e.target.value)}
              className="w-full p-3 bg-gray-900 border border-gray-600 rounded-lg text-white focus:border-green-500 focus:outline-none"
            >
              <option value="in_progress">در حال انجام</option>
              <option value="done">انجام شده</option>
            </select>
          </div>

          {/* ترتیب */}
          <div>
            <label className="block text-white font-medium mb-2">ترتیب:</label>
            <input
              type="number"
              value={formData.order}
              onChange={(e) => handleChange("order", e.target.value)}
              min="1"
              className="w-full p-3 bg-gray-900 border border-gray-600 rounded-lg text-white focus:border-green-500 focus:outline-none"
            />
          </div>
        </div>

        <div className="flex gap-3 pt-4 border-t border-gray-600">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 py-3 px-6 bg-gray-600 hover:bg-gray-700 text-white font-medium rounded-lg transition duration-200"
          >
            انصراف
          </button>
          <button
            type="submit"
            disabled={loading}
            className="flex-1 py-3 px-6 bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white font-medium rounded-lg transition duration-200 flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                در حال ایجاد...
              </>
            ) : (
              "ایجاد چلنج"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateChallengeForm;
